export const art70_item = [
    {
        "art70_item_nombre" : "XLSX",
        "art70_item_pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/transparencia/48_Rubros/xlsx/a70_f01_gCECULTAH.xlsx"
    },
    {
        "art70_item_nombre" : "Ver TABLA",
        "art70_item_pdf" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/transparencia/48_Rubros/htm/a70_f01_gCECULTAH.htm"
    },
]